import api from "./api";

class HighlightsService { 
  getHighlightByContentTypeId(contentTypeId) {
    return api.get(`v2/api/contents/highlights/${contentTypeId}`);
  }
}

export default new HighlightsService();